import CoveragePhaseService from "../../../api/services/operation/coverage-phase-service";
import { createNotification } from "../../../common/components";
import { translate } from "../../../common/providers";

export const exportPhaseStrategy = (projectId, phase, cancelToken) => {
	if (!phase?.deliverablesCount || phase.deliverablesCount === 0) {
		createNotification({ type: "error", message: translate("project-phases.export.no-deliverables") });
		return Promise.resolve();
	}

	return CoveragePhaseService.exportStrategy(
		{
			projectId,
			phaseId: phase.id,
		},
		cancelToken
	)
		.then((response) => {
			const contentDisposition = response.headers?.["content-disposition"];
			let filename = `coverage_export_${phase.date || new Date().toISOString()}.xlsx`;

			if (contentDisposition) {
				const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
				if (filenameMatch && filenameMatch[1]) {
					filename = filenameMatch[1].replace(/['"]/g, "");
				}
			}

			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement("a");
			link.href = url;
			link.download = filename;
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		})
		.catch((error) => {
			console.error("Download failed:", error);
		});
};
